import { INIT_FILTER_STATE } from "components/styled/filter/Filter.constants";
import { atom } from "jotai";
import type { PatientsFilters, PatientsFilterSettings, PatientsSortSettings } from "pages/Patients";

export const patientsCurrentPageAtom = atom<number>(1);
export const patientsFilterSettingsAtom = atom<PatientsFilterSettings | null>(null);
export const patientsSortingSettings = atom<PatientsSortSettings>(["-enrolled_date"]);
export const patientsFilters = atom<PatientsFilters>(INIT_FILTER_STATE);
